import moment from "moment";
export function formatDateToMonth(date) {
    const momentDate = moment(date);
    const currentYear = moment().year();
    if (momentDate.year() === currentYear) {
        return momentDate.format("MMMM");
    } else {
        return momentDate.format("MMMM 'YY");
    }
}
